import {Component, OnInit} from '@angular/core';
import {BmCreditorCamtImportConfigBaseComponent} from "../bm-creditor-camt-import-config-base.component";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";

@Component({
    selector: 'bm-creditor-camt-import-config-side',
    templateUrl: 'bm-creditor-camt-import-config-side.component.html',
    standalone: false
})
export class BmCreditorCamtImportConfigSideComponent extends BmCreditorCamtImportConfigBaseComponent implements OnInit {

    configDetailWidgetData: WidgetData;

    ngOnInit() {
        super.ngOnInit();
        this.initWidgets();
    }

    initWidgets() {
        this.configDetailWidgetData = WidgetFactory.createWidgetEntityData(
            'bm.creditor.camt.import.config.detail.side',
            'CAMT Import Konfiguration',
            'bm.CreditorCamtImportConfig',
            this.objectIdentifier.objectId
        );
    }
}
